import { Component, inject } from '@angular/core';
import { HostedNotificationsService } from './modules/desktop-notifications/hosted-notifications.service';
import { TabNotificationIndicatorService } from './modules/notification/services/tab-notification-indicator.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false,
})
export class AppComponent {
  public constructor() {
    inject(HostedNotificationsService);
    inject(TabNotificationIndicatorService);
  }
}
